export default "__VITE_ASSET__Dfcy9JTk__"